export default {
    sampleRate: 44100,
    normalSplit: 1 / 8,
    extendedSplit: 1 / 2,
};
